// extracted by mini-css-extract-plugin
module.exports = {"root":"G_bJ","checked":"G_cJ"};